import { serviceRequest } from 'utils/http';
import { SendInvitationLinkDto, Service } from 'common/api';

export function sendInvitationLinkEmailAPI(requestBody: SendInvitationLinkDto) {
  return serviceRequest(() => Service.siteEmployeeControllerSendInvitationLinkEmail(requestBody));
}
